import React, {useEffect, useRef} from "react";
import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import SubTagPlentyCard from "./subTag/SubTagPlentyCard";
import useFilterUser from "../../custom-hooks/useFilterUser";
import {loadAllTagCategories} from "./tagCategory/tagCategoryAction";

const TagListInput = ({selectedTags, setSelectedTags, isLimitedItem = false, actionName}) => {

    const addTag = (tag_data) => {
            if (!selectedTags.some(tag => tag.id === tag_data.id)) {
                setSelectedTags([...selectedTags, tag_data]);
            }
    }

    const {tagCategories: categories} = useSelector(state => state.tagCategories)
    const {availableTags: actionAvailableTags} = useSelector(state => state.action)
    const {availableTags: objectiveAvailableTags} = useSelector(state => state.objective)
    const {tags: projectAvailableTags} = useSelector(state => state.project)

    const dispatch = useDispatch()

    useEffect(() => {
        if (!isLimitedItem) {
            dispatch(loadAllTagCategories())
        }
    }, [dispatch, isLimitedItem])

    const inputRef = useRef()

    useEffect(() => {
        inputRef.current.focus()
    }, [])


    const removeTag = (tag_data) => {
        setSelectedTags(selectedTags.filter(t => t.name !== tag_data.name))
    }


    const getEachTagOfEachCategory = () => {
        let array = []
        if (categories && categories.length > 0) {
            categories.forEach((i) => {
                i.tags.forEach((t) => {
                    array.push(t)
                })
            })
        }
        return array
    }
    const getEachTag = () => {
        let initTags
        if (actionAvailableTags?.length === 0 && objectiveAvailableTags?.length === 0) {
            initTags = projectAvailableTags
        } else {
            initTags = actionName === "actions" ? actionAvailableTags : objectiveAvailableTags
        }
        let array = []
        if (initTags && initTags.length > 0) {
            initTags.forEach((i) => {
                array.push(i)
            })
        }
        return array
    }

    const getItems = () => {
        if (isLimitedItem) {
            return getEachTag()
        } else {
            return getEachTagOfEachCategory()
        }
    }
    const {
        query,
        setQuery
    } = useFilterUser(getItems())


    return (
        <List className={"flex-col gap-05"}>
            <SearchZone>
                {selectedTags && selectedTags
                    .map(st => (
                        <SubTagPlentyCard
                            key={st.id}
                            id={st.id}
                            color={st.color}
                            name={st.name}
                            category={st.category}
                            handleTag={removeTag}
                            action={"remove"}
                        />
                    ))}
                <div>
                    <input ref={inputRef} autoFocus={true} placeholder={"chercher un tag"} type={"text"} onChange=
                        {e => {
                            setQuery(e.target.value)
                        }}/>
                </div>
            </SearchZone>
            <ContainerTag className={"flex-col gap-05"}>
                {getItems()
                    .filter(tag =>
                        tag.name.toLowerCase().includes(query.toLowerCase()) ||
                        tag.category.toLowerCase().includes(query.toLowerCase())
                    )
                    .map(tag => (
                        <div id={"tag-card-wrapper"}
                             key={tag.id}
                        >
                            <SubTagPlentyCard
                                id={tag.id}
                                color={tag.color}
                                name={tag.name}
                                category={tag.category}
                                handleTag={addTag}
                                action={"add"}

                            />
                        </div>
                    ))}
            </ContainerTag>
        </List>
    )
}

const List = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background-color: var(--color-white);
  padding: 0;
  border-radius: 10px;
  width: 300px;
  transform: translateY(5%);
  box-shadow: rgb(15 15 15 / 5%) 0 0 0 1px, rgb(15 15 15 / 10%) 0 3px 6px, rgb(15 15 15 / 20%) 0 9px 24px;
  overflow-x:auto;
`
const SearchZone = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em;
  width: 100%;
  padding: 0.5em 1em;
  background-color: rgba(242, 241, 238, 0.6);
  box-shadow: rgb(55 53 47 / 16%) 0px -1px inset;
  cursor: text;

  input[type=text] {
    width: 100%;
    border: none;
    background-color: transparent;

    &:focus {
      outline: transparent;
    }
  }
`

const ContainerTag = styled.div`
  padding: 1em;
  justify-content: center;
  width: 100%;
  background-color: var(--color-white);

  #tag-card-wrapper {
    display: flex;
  }
`
export default TagListInput;